<script lang="ts">
    import {Rose} from "../rose.ts";
    import {Link} from "svelte-routing";

    export let rose: Rose;
    export let block: boolean = true;
</script>

<Link to="detalls/{rose.id}">
    <div class="gallery-element">
        <img src="{rose.src}" alt="Rosa" class:block-image={block}>
        <div class="gallery-element-info">
            <p>Descripció: "{rose.description}"</p>
            <p>Estil de: {rose.artist}</p>
        </div>
    </div>
</Link>

<style>
    .gallery-element {
        max-width: 400px;
        max-height: 400px;
        position: relative;
    }

    .gallery-element img {
        width: 100%;
    }

    .block-image {
        display: block;
    }

    .gallery-element-info {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0.5em 2em;
        background-color: #00000088;
        color: white;
        opacity: 0;
    }

    .gallery-element-info > p {
        font-size: 1.25em;
        margin: 0.5em 0;
    }

    @keyframes show-image-info {
        from {
            transform: scaleY(0);
            opacity: 0;
        }
        to {
            transform: scaleY(1);
            opacity: 1;
        }
    }

    @keyframes dim-image {
        from {
            filter: brightness(100%);
        }
        to {
            filter: brightness(80%);
        }
    }

    .gallery-element:hover .gallery-element-info {
        transform-origin: center bottom;
        animation: show-image-info .2s ease-in-out;
        opacity: 1;
    }

    .gallery-element:hover img {
        animation: dim-image .2s ease-in-out;
        filter: brightness(80%);
    }

</style>